<section class="dictionary-section section-pd bg-light-purple card-carousel">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>Built in Domain-Specific Dictionaries</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>

        <div id="dictionaries-carousel"
            class="carousel slide"
            data-ride="carousel"
            role="region"
            aria-roledescription="carousel"
            [attr.aria-label]="carouselData.label">

            <div class="row align-items-center justify-content-center">

                <!-- LEFT: INDICATORS -->
                <div class="col-lg-6 col-md-6">

                    <div class="carousel-indicators position-relative" role="tablist" aria-label="Dictionary categories">

                        <button *ngFor="let slide of carouselData.slides; let i = index"
                                type="button"
                                role="tab"
                                id="tab-{{i}}"
                                data-target="#dictionaries-carousel"
                                [attr.data-slide-to]="i"
                                [class.active]="activeSlide === i"
                                [attr.aria-selected]="activeSlide === i"
                                [attr.aria-label]="slide.title"
                                [attr.aria-controls]="'slide-' + i"
                                (click)="activeSlide = i">

                            <span>{{ slide.title }}</span>
                        </button>

                        <!-- decorative lines -->
                        <span class="trinka-line hr-line left-33" aria-hidden="true"></span>
                        <span class="trinka-line hr-line left-66" aria-hidden="true"></span>
                        <span class="trinka-line vr-line top-33" aria-hidden="true"></span>
                        <span class="trinka-line vr-line top-66" aria-hidden="true"></span>

                    </div>
                </div>

                <!-- RIGHT: SLIDES -->
                <div class="col-lg-6 col-md-6">

                <div class="ct-card position-relative">

                    <!-- screen reader announcer -->
                    <div class="sr-only"
                        id="carousel-announcer"
                        aria-live="polite"></div>

                        <div class="carousel-inner"
                            aria-live="polite"
                            -atomic="true"
                        >

                            <div class="carousel-item"
                                *ngFor="let slide of carouselData.slides; let i = index"
                                [id]="'slide-' + i"
                                [class.active]="activeSlide === i"
                                [attr.aria-hidden]="activeSlide !== i"
                                role="tabpanel"
                                [attr.aria-labelledby]="'tab-' + i">

                                <div class="carousel-card">

                                    <h4>{{ slide.title }}</h4>

                                    <p [innerHTML]="slide.html"></p>

                                </div>

                            </div>

                        </div>

                    <!-- controls -->
                    <button class="carousel-control-prev"
                            type="button"
                            data-target="#dictionaries-carousel"
                            data-slide="prev"
                            aria-label="Previous Slide">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    </button>

                    <button class="carousel-control-next"
                            type="button"
                            data-target="#dictionaries-carousel"
                            data-slide="next"
                            aria-label="Next Slide">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    </button>

                </div>
                </div>

            </div>
        </div>

    </div>
</section>